"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'Process',
  props: {
    fileImportProcessUniqueCode: {
      type: String,
      default: null
    },
    showClose: {
      type: Boolean,
      default: true
    },
    showResult: {
      type: Boolean,
      default: false
    },
    getImportProcess: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      interval: null,
      sourceApi: null,
      active: 0,
      // 当前进度
      maxActive: 0,
      // 最大进度
      missionCount: 0,
      // 剩余任务执行次数
      hasError: false,
      // 错误状态
      isError: false,
      // 控制错误时的样式
      errMsg: '',
      // 后端错误信息
      errData: '' // 后端报错原因
    };
  },
  computed: {
    isShowClose: {
      get: function get() {
        return this.showClose;
      },
      set: function set(val) {
        this.$emit('update:showClose', val);
      }
    },
    isShowResult: {
      get: function get() {
        return this.showResult;
      },
      set: function set(val) {
        this.$emit('update:showResult', val);
      }
    }
  },
  watch: {
    maxActive: function maxActive(newValue, oldValue) {
      var _this = this;
      // 通过设置maxActive来缓存最新进度来防止后端执行过快时进度条动画直接结束，控制进度条变化时最短间隔为800ms
      var count = newValue - oldValue;
      for (var i = 1; i <= count; i++) {
        setTimeout(function () {
          _this.active++;
          _this.missionCount--;
          if (_this.hasError && _this.missionCount <= 0) {
            _this.setError();
          }
          if (_this.active >= 4) {
            _this.isShowClose = true;
            _this.$emit('animeSuccess');
          }
        }, (this.missionCount + i) * 800);
      }
      this.missionCount += count;
    }
  },
  mounted: function mounted() {
    // this.start()
  },
  beforeUnmount: function beforeUnmount() {
    this.end();
  },
  methods: {
    start: function start() {
      var _this2 = this;
      // 间隔请求文件上传进度结果
      this.isShowClose = false;
      // this.getProcess()
      this.interval = setInterval(function () {
        _this2.getProcess();
      }, 1000);
    },
    end: function end() {
      // 结束间隔请求
      clearInterval(this.interval);
      this.$emit('end');
    },
    handleEnd: function handleEnd(res) {
      // 导入结果成功或失败时
      if (res.data.code === 'EXCEL_END_SUCCESS') {
        this.maxActive = 4;
      } else {
        this.maxActive = 3;
        this.hasError = true;
        this.errMsg = res.data.msg;
        this.errData = res.data.data || '';
        // 后端返回失败时maxActive没有变化的情况
        if (this.active === this.maxActive) {
          this.setError();
        }
      }
    },
    setError: function setError() {
      // 设置错误时的样式
      this.$emit('error');
      this.isError = true;
      this.isShowClose = true;
      this.$message.error(this.errMsg);
      // 显示结果按钮
      if (this.active === 3) {
        this.isShowResult = true;
      }
    },
    handleError: function handleError(res, status) {
      // 发生错误时的处理
      this.maxActive = status;
      this.hasError = true;
      this.errMsg = res.data.msg;
      this.errData = res.data.data || '';
      // 后端返回失败时maxActive没有变化的情况
      if (this.active === this.maxActive) {
        this.setError();
      }
    },
    // eslint-disable-next-line sonarjs/cognitive-complexity
    getProcess: function getProcess() {
      var _this3 = this;
      // 间隔请求
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      this.$api.common.getImportProcess(this.fileImportProcessUniqueCode, this.sourceApi.token).then(function (res) {
        // finishFlag来判断后端处理是否结束
        if (res.data.finishFlag) _this3.end();
        // 开始读取
        if (res.data.code === 'EXCEL_START') _this3.maxActive = 0;
        // 检查表头
        if (res.data.code === 'EXCEL_HEAD_START') _this3.maxActive = 1;
        // 表头检查出现错误
        if (res.data.code === 'EXCEL_HEAD_END_REPEAT' || res.data.code === 'EXCEL_HEAD_END_EMPTY' || res.data.code === 'EXCEL_HEAD_END_LOST') _this3.handleError(res, 1);
        // 检查数据
        if (res.data.code === 'EXCEL_VALID_DATA') _this3.maxActive = 2;
        // 数据检查出现错误
        if (res.data.code === 'EXCEL_END_INVALID_DATA') _this3.handleError(res, 2);
        // 数据导入
        if (res.data.code === 'EXCEL_EXECUTE_DATA') _this3.maxActive = 3;
        // 导入结果
        if (res.data.code === 'EXCEL_END_SUCCESS' || res.data.code === 'EXCEL_END_FAIL' || res.data.code === 'EXCEL_END_EXCEPTION') _this3.handleEnd(res);
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this3.end();
        _this3.isShowClose = true;
      });
    },
    setIcon: function setIcon(active, icon) {
      return this.active === active && !this.isError ? 'el-icon-loading' : icon;
    },
    setStatus: function setStatus(active) {
      return this.active === active && this.isError ? 'error' : '';
    },
    setDescription: function setDescription(active) {
      if (this.active === active && this.isError) return this.errData || this.$t('Progress.fail');
      if (this.active === active) return this.$t('Progress.progress');
      if (this.active < active) return this.$t('Progress.wait');
      return this.$t('Progress.complete');
    }
  }
};